<script setup lang="ts">
import CourseStoreView from 'modules/Course/views/CourseStoreView/CourseStoreView.vue';
import BPage from 'src/shared/components/base/BPage/BPage.vue';
</script>

<template>
  <BPage>
    <div class="col fit">
      <CourseStoreView />
    </div>
  </BPage>
</template>
